export function reloadPage () {
  const CURRENT_HREF = window.location.href;

  window.location.replace(CURRENT_HREF);
};
